import React, { useRef } from 'react';

import { Nav, Navbar } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import '../css/menu.css';

function Menu(props) {
  const menuPage = useRef();
  const navbar = useRef();

  //mouse location bg move
  const moveBg = e => {
    e.persist();

    const desktopRes = window.matchMedia('(min-width: 1026px)');

    if (desktopRes.matches) {
      const page = e.currentTarget;

      let { clientX: x, clientY: y } = e;
      let { offsetWidth: width, offsetHeight: height } = e.currentTarget;

      if (menuPage.current !== e.target) {
        x = Math.floor(width / 2 - x + width * 3) + navbar.current.offsetLeft;
        y = Math.floor(height / 2 - y + height * 3) + navbar.current.offsetTop;

        console.log(y);
      }

      page.style.backgroundPositionX = x / 100 + '%';
      page.style.backgroundPositionY = y / 100 + '%';
    }
  };

  return (
    <section
      onMouseMove={e => moveBg(e)}
      id='menu'
      className={`${props.openMenu ? 'transition' : ''}`}
    >
      <Navbar ref={menuPage}>
        <Nav ref={navbar}>
          <LinkContainer
            onClick={e => {
              props.setSelected('home');
              props.setOpenMenu(!props.openMenu);
            }}
            className={
              props.selected.includes('home') ? 'currently-selected' : ''
            }
            to='/homepage'
          >
            <Nav.Item>
              <p>Home</p>
              <p>Home</p>
            </Nav.Item>
          </LinkContainer>
          <LinkContainer
            onClick={e => {
              props.setSelected('about');
              props.setOpenMenu(!props.openMenu);
            }}
            className={
              props.selected.includes('about') ? 'currently-selected' : ''
            }
            to='/about'
          >
            <Nav.Item>
              <p>About</p>
              <p>About</p>
            </Nav.Item>
          </LinkContainer>
          <LinkContainer
            onClick={e => {
              props.setSelected('projects');
              props.setOpenMenu(!props.openMenu);
            }}
            className={
              props.selected.includes('projects') ? 'currently-selected' : ''
            }
            to='/projects'
          >
            <Nav.Item>
              <p>Projects</p>
              <p>Projects</p>
            </Nav.Item>
          </LinkContainer>
          <LinkContainer
            onClick={e => {
              props.setSelected('contact');
              props.setOpenMenu(!props.openMenu);
            }}
            className={
              props.selected.includes('contact') ? 'currently-selected' : ''
            }
            to='/contact'
          >
            <Nav.Item>
              <p>Contact</p>
              <p>Contact</p>
            </Nav.Item>
          </LinkContainer>
        </Nav>
      </Navbar>
    </section>
  );
}

export default Menu;
